<template>
  <!-- sits in TasksCard's padded body, which owns the spacing and the divider above -->
  <v-card variant="flat">
    <v-card-title v-if="tasksLength" class="pa-0 pt-2 d-flex justify-center">
      <v-card-actions>
        <v-btn
          color="primary"
          variant="text"
          data-track="task.create-form.open"
          @click="showCreateTask = true"
        >
          <v-icon start>mdi-plus</v-icon>
          New Task
        </v-btn>
      </v-card-actions>
    </v-card-title>
    <v-card-text v-else class="text-center pa-0">
      <p class="mb-4">
        Create a task for yourself or a teammate. Keep track of all your
        to-dos for this record.
      </p>
      <v-btn
        color="primary"
        variant="flat"
        data-track="task.create-form.open"
        @click="showCreateTask = true"
      >
        Create Task
      </v-btn>
    </v-card-text>
    <CreateTaskForm
      v-model="showCreateTask"
      :associated-records="associatedRecords"
      :collection-type="collectionType"
      @submit="onSubmit"
    />
  </v-card>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import { DialogMixin } from '@/bundles/Dialogs/mixins/DialogMixin';

import CreateTaskForm from '@/bundles/Tasks/components/CreateTaskForm.vue';

interface IRecordTaskCard {
  showCreateTask: boolean;
}

export default defineComponent({
  name: 'RecordTaskCard',

  components: { CreateTaskForm },
  mixins: [DialogMixin],

  props: {
    tasksLength: {
      type: Number,
      default: 0
    },
    associatedRecords: {
      type: Array,
      default: () => []
    },
    collectionType: {
      type: String,
      default: '',
    }
  },

  data: (): IRecordTaskCard => ({
    showCreateTask: false
  }),

  methods: {
    onSubmit: function () {
      this.$eventBus.$emit('fetch:tasks');
    }
  }
})
</script>
